






































































































































































































































import { Component, Vue } from 'vue-property-decorator';

   @Component({
    })

export default class TicketReservationMonitor extends Vue{

  mockData:any[]=[];
  headers:any[]=[];
  startDate:Date=null;
  endDate:Date=null;
  breadcrumbsItems:any[]=[];
  active_tab:number=0;

    created(){
      this.headers= [
          { text: 'Sipariş No',  align: 'start',filterable: false,   value: 'orderNo', },
          { text: 'Sipariş Tarihi', value: 'orderDate' },
          { text: 'Sipariş Durumu', value: 'orderStatus' },
          { text: 'Operasyon Durumu', value: 'operationStatus' },
          { text: 'Fiyat', value: 'price' },
          { text: 'Müşteri', value: 'customer' },
          { text: 'E-posta Durumu', value: 'mailStatus' },
          { text: 'SMS Durumu', value: 'smsStatus' },



        ],
        this.mockData=[
          {
            orderNo: 'xxx',
            orderDate: 'yyy',
            orderStatus: 'zzz',
            operationStatus: 'aaa',
            price: 'uuu',
            customer: 'kkk',
            mailStatus: 'kkk',
            smsStatus: 'kkk',
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Bilet',disabled: true},
          {text: 'Bilet Rezervayon Monitörü',disabled: true}
        
      ]

    }

    data () {
      return {
        page: 1,
        
      }
      

    
}

}


